// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0815aa26c8cadab4f4dc532131e39c420ea0f4fa/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};